'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _ButtonTooltip = require('../ButtonTooltip/ButtonTooltip');

var _ButtonTooltip2 = _interopRequireDefault(_ButtonTooltip);

require('./DropdownList.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownList = function (_Component) {
  (0, _inherits3.default)(DropdownList, _Component);

  function DropdownList(props) {
    (0, _classCallCheck3.default)(this, DropdownList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DropdownList.__proto__ || (0, _getPrototypeOf2.default)(DropdownList)).call(this, props));

    _this.state = {
      open: false
    };
    return _this;
  }

  (0, _createClass3.default)(DropdownList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Automatically close the dropdown list when this param comes to true.
      if (nextProps.closed === true) {
        this.setState({
          open: !nextProps.closed
        });
      }
    }
  }, {
    key: 'toggleList',
    value: function toggleList(event) {
      event.preventDefault();

      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'DropdownList' },
        this.props.content && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _ButtonTooltip2.default,
            {
              className: (0, _classname2.default)("DropdownList__toggle no-text-transform"),
              'aria-label': this.props.ariaLabel,
              'aria-expanded': this.state.open,
              'aria-controls': this.props.id,
              onClick: this.toggleList.bind(this)
            },
            _react2.default.createElement('span', { className: (0, _classname2.default)("DropdownList__icon icon", { "icon-plus": !this.state.open }, { "is-open": this.state.open }) }),
            this.props.title
          ),
          _react2.default.createElement(
            'div',
            {
              id: this.props.id,
              className: (0, _classname2.default)("DropdownList__dropdown", { "is-open": this.state.open })
            },
            this.props.content
          )
        ),
        !this.props.content && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: (0, _classname2.default)("DropdownList__toggle no-text-transform") },
            this.props.title
          )
        )
      );
    }
  }]);
  return DropdownList;
}(_react.Component);

DropdownList.propTypes = {
  id: _propTypes2.default.string.isRequired,
  ariaLabel: _propTypes2.default.string,
  title: _propTypes2.default.object,
  content: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
  closed: _propTypes2.default.bool
};

DropdownList.defaultProps = {
  title: {},
  content: false,
  closed: true
};

exports.default = DropdownList;


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/DropdownList/DropdownList.js
// module id = 1164
// module chunks = 0